<script setup lang="ts">
import { computed } from 'vue'
import { useIdeStore } from '@/stores/ide.store'
const ideStore = useIdeStore()

const isFullScreen = computed(() => {
  return ideStore.isFullScreen
})
const showOutputFiles = computed(() => {
  return ideStore.isOutputFiles && ideStore.isOutputFiles.length > 0
})
const outputFiles = computed(() => {
  return ideStore.isOutputFiles
})
/**
 * Gets the download url for the output file
 * @param file The file name
 * @returns The url
 */
const getUrlOutput = (file: string) => {
  return `/api/projectSync/downloadItem?projectKey=${
    ideStore.projectKey ? encodeURI(ideStore.projectKey as string) : '1001'
  }&name=${encodeURI(file)}&type=output`
}
</script>

<template>
  <div
    :class="[
      'surface-secondary-header mt-3 flex h-auto w-full flex-col sm:mt-5',
      {
        'min-w-full max-w-md': isFullScreen
      },
      {
        'min-w-max': !isFullScreen
      }
    ]"
  >
    <div class="surface-secondary-header h-full min-h-10 w-full p-5">
      <ul v-if="showOutputFiles">
        <li
          v-for="file in outputFiles"
          :key="file"
          class="flex items-baseline justify-between gap-5 py-1"
        >
          <p class="p-xsmall">{{ file }}</p>
          <a :href="getUrlOutput(file)" target="_blank">
            <FontAwesomeIcon icon="fa-download" class="flex h-3 w-3" />
          </a>
        </li>
      </ul>
      <p v-else class="p-xsmall">No files generated</p>
    </div>
  </div>
</template>
